import React from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {borderRadius, display, flexAlignCenter, m, mr, onDesktop, p} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

interface IProps {
    categories: (
        | {
              id: number;
              name: string;
              slug: string;
          }
        | undefined
    )[];
    className?: string;
}
export const ArticleCategoriesBar: React.FunctionComponent<IProps> = (props) => {
    const theme = useTheme();

    return (
        <div css={flexAlignCenter} className={props.className}>
            <Text color={theme.colors.gray[700]} css={[mr(2), onDesktop(mr(4))]} variant="info_txt_1">
                KATEGORIE:
            </Text>
            <ul css={[categoriesList, flexAlignCenter]}>
                {props.categories.map(
                    (category) =>
                        category && (
                            <Text as="li" variant="info_txt_2" css={[m(0, 1, 1, 0), onDesktop(m(0, 2, 1, 0))]} key={category.id}>
                                <a css={categoryButton} href={rpAppLink.article.category({categorySlug: category.slug})}>
                                    {category.name}
                                </a>
                            </Text>
                        )
                )}
            </ul>
        </div>
    );
};

const categoryButton = (theme: Theme) => css`
    ${borderRadius(2)};
    ${p(1, 3)};
    ${display("block")};
    background-color: ${theme.colors.gray[200]};
`;

const categoriesList = css`
    ${p(0)};
    ${flexAlignCenter};
    list-style: none;
    flex-wrap: wrap;
`;
import React from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {borderRadius, display, flexAlignCenter, m, mr, onDesktop, p} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

interface IProps {
    categories: (
        | {
              id: number;
              name: string;
              slug: string;
          }
        | undefined
    )[];
    className?: string;
}
export const ArticleCategoriesBar: React.FunctionComponent<IProps> = (props) => {
    const theme = useTheme();

    return (
        <div css={flexAlignCenter} className={props.className}>
            <Text color={theme.colors.gray[700]} css={[mr(2), onDesktop(mr(4))]} variant="info_txt_1">
                KATEGORIE:
            </Text>
            <ul css={[categoriesList, flexAlignCenter]}>
                {props.categories.map(
                    (category) =>
                        category && (
                            <Text as="li" variant="info_txt_2" css={[m(0, 1, 1, 0), onDesktop(m(0, 2, 1, 0))]} key={category.id}>
                                <a css={categoryButton} href={rpAppLink.article.category({categorySlug: category.slug})}>
                                    {category.name}
                                </a>
                            </Text>
                        )
                )}
            </ul>
        </div>
    );
};

const categoryButton = (theme: Theme) => css`
    ${borderRadius(2)};
    ${p(1, 3)};
    ${display("block")};
    background-color: ${theme.colors.gray[200]};
`;

const categoriesList = css`
    ${p(0)};
    ${flexAlignCenter};
    list-style: none;
    flex-wrap: wrap;
`;
